import * as React from 'react';
import { H3Regular, isEmpty, useThemeColors, YStack } from 'smoothie';

import Logo from '../../../../assets/images/logos/logo-new.svg';
import { StorageKeys } from '../../../common/constants';
import { properCase } from '../../../common/misc';
import { useStorage } from '../../../common/providers/StorageProvider';
import { captureWarning } from '../../../logger/Logger';
import type { MemberInfo } from '../../../user/types/User';

const Greeting = () => {
    const { getColor } = useThemeColors();
    const storage = useStorage();
    let memberInfo: MemberInfo = {};
    const rawMemberInfo = storage.getString(StorageKeys.MEMBER_INFO);
    try {
        memberInfo = (
            rawMemberInfo != null && !isEmpty(rawMemberInfo.trim())
                ? JSON.parse(rawMemberInfo)
                : {}
        ) as MemberInfo;
    } catch (err) {
        captureWarning('Invalid JSON found in StorageKeys.MEMBER_INFO', err);

        // Clear the invalid json value.
        storage.removeItem(StorageKeys.MEMBER_INFO);
    }

    return (
        <YStack gap={12} alignItems="center">
            <Logo height={24} color={getColor('$black')} />

            <H3Regular>
                {memberInfo?.firstName != null
                    ? `Welcome back, ${properCase(memberInfo.firstName)}.`
                    : 'Welcome to Fruitful'}
            </H3Regular>
        </YStack>
    );
};

export default Greeting;
